import { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import useScrollDirection from './useScrollDirection';

function useBlogNavbar() {
  const { isScrollingDown: isInvisible } = useScrollDirection();

  const { pathname, asPath: activeItem } = useRouter();

  const [isDark, setIsDark] = useState(false);

  const onScroll = useCallback(() => {
    const { scrollY } = window;

    if ((isDark && !scrollY) || (!isDark && scrollY)) {
      setIsDark(scrollY > 50);
    }
  }, [isDark]);

  useEffect(() => {
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);

  return { isDark, isInvisible, activeItem, pathname };
}

export default useBlogNavbar;
